import { Injectable } from '@angular/core';

const PAT_LOCAL_STORAGE_KEY = 'public_access_terminal'

@Injectable()
export class PublicAccessTerminalService {

  constructor() { }

  isPublicAccessTerminal(): boolean {
    return !!window.localStorage.getItem(PAT_LOCAL_STORAGE_KEY);
  }

  setAsPublicAccessTerminal(value: boolean): void {
    if (!!value) {
      window.localStorage.setItem(PAT_LOCAL_STORAGE_KEY, true.toString());
    } else {
      window.localStorage.removeItem(PAT_LOCAL_STORAGE_KEY)
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/public-access-terminal.service.ts